import React from 'react';

interface FloatingToolbarProps {
  onBold: () => void;
  onItalic: () => void;
  onCode: () => void;
  position: { start: number; end: number };
}

export const FloatingToolbar: React.FC<FloatingToolbarProps> = ({
  onBold,
  onItalic,
  onCode,
  position
}) => {
  return (
    <div className="fixed z-50 bg-white/95 backdrop-blur-md border border-ghost-200 rounded-lg shadow-lg animate-float-up">
      <div className="flex items-center p-1">
        <button
          onClick={onBold}
          className="p-2 hover:bg-ghost-100 rounded text-ghost-600 hover:text-ghost-800 transition-colors duration-150"
          aria-label="Negrito"
        >
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M5 4a1 1 0 011-1h3a3 3 0 110 6H6v2h3.5a2.5 2.5 0 010 5H6a1 1 0 01-1-1V4zm2 1v3h2a1 1 0 100-2H7zm0 6v3h2.5a.5.5 0 000-1H7z" clipRule="evenodd" />
          </svg>
        </button>
        
        <button
          onClick={onItalic}
          className="p-2 hover:bg-ghost-100 rounded text-ghost-600 hover:text-ghost-800 transition-colors duration-150"
          aria-label="Itálico"
        >
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M8 2a1 1 0 000 2h.24l-1.25 12H6a1 1 0 100 2h4a1 1 0 100-2h-.24l1.25-12H12a1 1 0 100-2H8z" clipRule="evenodd" />
          </svg>
        </button>
        
        <div className="w-px h-4 bg-ghost-200 mx-1" />
        
        <button
          onClick={onCode}
          className="p-2 hover:bg-ghost-100 rounded text-ghost-600 hover:text-ghost-800 transition-colors duration-150"
          aria-label="Código"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
          </svg>
        </button>
      </div>
      
      {/* Arrow pointing down */}
      <div className="absolute top-full left-1/2 transform -translate-x-1/2">
        <div className="w-2 h-2 bg-white/95 border-r border-b border-ghost-200 transform rotate-45 -mt-1" />
      </div>
    </div>
  );
};